export enum CurrencyType {
  USR = "USR",
  ARS = "ARS"
}
